<template>
    <div @click="close">
        <transition name="fade" enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut"
                    :duration="300">
            <div class="cover-layer" v-show="isHotCityShow"></div>
        </transition>
        <transition name="bounce" enter-active-class="animated bounceInUp"
                    leave-active-class="animated fadeOut"
                    :duration="500">
            <div class="m-search-content" v-show="isHotCityShow" ref="hotCity">
                    <ul class="content-list">
                        <li class="list-item">
                            <div class="list-content">
                                <div v-for="item in cityData" @click.stop="selectHotel(item)"> {{item.Name}}</div>
                            </div>
                        </li>
                    </ul>
            </div>
        </transition>
        <transition name="fade" enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut"
                    :duration="300">
            <div class="cover-layer" v-show="isTypeShow"></div>
        </transition>
        <transition name="bounce" enter-active-class="animated bounceInUp"
                    leave-active-class="animated fadeOut"
                    :duration="500">
            <div class="m-search-content" v-show="isTypeShow" style="width: 160px;" ref="isType">
                    <ul class="content-list">
                        <li class="list-item">
                            <div class="list-content">
                                <div @click.stop="selectType(1)">日历套餐</div>
                                <div @click.stop="selectType(2)">预约套餐</div>
                                <div @click.stop="selectType(0)">全部类型</div>
                            </div>
                        </li>
                    </ul>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
  name: "HotCity",
  props: {
    isHotCityShow: {
      type: Boolean,
      default: false
    },
    isTypeShow: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      cityData: JSON.parse(this.dao.get('getPackageHotCity'))
    };
  },

  watch: {
    isHotCityShow(val) {
        this.cityData = JSON.parse(this.dao.get('getPackageHotCity'))
    }
  },
  methods: {
    selectHotel(obj) {
      this.$emit("select", obj);
    },

    selectType(index) {
      this.$emit("select", index);
    },

    close(){
      this.selectType()
      this.selectHotel()
    }
  },
  mounted() {
			var that = this
			that.$nextTick(() => {
        if(localStorage.getItem('lang')=='t'){
          if(localStorage.getItem('lang')=='t'){
            that.$zh_tran(localStorage.getItem('lang'))
          }    
        }
			})
	}
};
</script>

<style scoped>
.m-search-content {
  width: 535px;
  top:40px;
}
.m-search-content .list-item .list-content > div {
  width: 82px;
}

.m-search-content .list-item .list-content > div:hover {
  color: #fff;
  background-color: #28c667;
}
</style>



// WEBPACK FOOTER //
// src/components/package/comm/HotCity.vue